<template>
  <div class="page">
    <c-source-detail
      :columns="columns"
      :data="data"
      resource="users"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class UserDetail extends Vue {
  data = {}

  get columns() {
    return createColumns.call(this, {
      actionColumn: { detail: false }
    });
  }

  async mounted() {
    this.fetchData();
  }

  async fetchData() {
    this.data = await this.$request.get(`/users/${this.$route.params.id}`);
  }
}
</script>
